

function Footer() {
    return (
        <footer className="bg-primary mt-xxl-5  py-4">
            <p className="text-white mb-0 text-center">
                Copyright &copy; {new Date().getFullYear()} REMA
            </p>
        </footer>
    );
}

export default Footer;